<template>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark">
                Exibindo de {{ quantidadeExibindoInicio() }} até {{ quantidadeExibindoFim() }} (de um total de {{ quantidadeTotal }})
              </span>
              <span class="text-muted mt-3 font-weight-bold font-size-sm">
                Acompanhe em tempo real todos as transações programadas cadastrados pelo seu estabelecimento
              </span>
            </h3>
            <div class="card-toolbar">
              <div class="input-icon h-40px">
                <input
                  type="text"
                  class="form-control form-control-lg form-control-solid h-40px"
                  v-model="buscarComputado"
                  placeholder="Buscar..."
                  :disabled="isLoading"
                />
                <span>
                  <span class="svg-icon svg-icon-lg">
                    <!--begin::Svg Icon-->
                    <inline-svg src="media/svg/icons/General/Search.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <router-link to="/transacaoprogramada" v-slot="{ href, navigate }">
                <a
                  :href="href"
                  @click="navigate"
                  class="btn btn-primary font-weight-bolder text-uppercase"
                  style="margin-left: 10px;"
                >
                  Nova transação
                </a>
              </router-link>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2 pb-0">
            <div class="row" style="margin-top: 10px; margin-bottom: 10px;" v-if="isLoading">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <strong style="margin-right: 10px;">Carregando...</strong>
                  <b-spinner class="ml-auto"></b-spinner>
                </div>
              </div>
            </div>
            <!--begin::Table-->
            <div class="table-responsive" style="overflow-x: initial">
              <b-table 
                striped 
                hover 
                :items="items" 
                :fields="fields" 
                :sort-by.sync="sortBy" 
                :sort-desc.sync="sortDesc" 
                @sort-changed="listar" 
                @row-clicked="visualizar"
              >
              </b-table>
            </div>
            <b-pagination 
              v-model="pagina" 
              @change="listar" 
              :per-page="quantidade" 
              :total-rows="quantidadeTotal" 
              :disabled="isLoading"
              :limit="7" 
              pills 
              align="center"
            ></b-pagination>
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
  
  export default {
    name: "TransacoesProgramadas",
    data() {
      return {
        buscar: "",
        pagina: 1,
        quantidade: 10,
        quantidadeTotal: 0,
        isLoading: false,
        timeoutBusca: null,
        items: [],
        sortBy: "RAZAO_SOCIAL",
        sortDesc: false,
        fields: [
          {
            key: 'ID_EMITENTE',
            label: 'Identificador',
            sortable: true
          },
          {
            key: 'RAZAO_SOCIAL',
            label: 'Descrição',
            sortable: true
          },
          {
            key: 'CGC_CPF',
            label: 'CPF / CNPJ',
            sortable: true
          }
        ]
      };
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Emitentes" }
      ]);
  
      this.listar();
    },
    computed: {
      buscarComputado: {
        get: function() {
          return this.buscar;
        },
        set: function(value) {
          this.buscar = value;
  
          if (this.timeoutBusca) {
            clearTimeout(this.timeoutBusca);
          }
  
          this.timeoutBusca = setTimeout(() => {
            this.listar();
          }, 1000);
        }
      }
    },
    methods: {
      ...mapActions(["getEmitentesLista"]),
      listar() {
        this.$nextTick(async () => {
          this.isLoading = true;
  
          let emitentes = await this.getEmitentesLista({
            pagina: this.pagina,
            quantidade: this.quantidade,
            buscar: this.buscar,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc
          });
  
          this.quantidadeTotal = emitentes.QUANTIDADE_TOTAL;
          this.items = emitentes.ITEMS;
  
          this.isLoading = false;
        });
      },
      quantidadeExibindoInicio() {
        let quantidade = ((this.pagina - 1) * this.quantidade);
  
        if(quantidade > 0) {
          return quantidade + 1;
        } else {
          return 1;
        }
      },
      quantidadeExibindoFim() {
        let quantidade = (this.pagina * this.quantidade);
  
        if(quantidade < this.quantidadeTotal) {
          return quantidade;
        } else {
          return this.quantidadeTotal;
        }
      },
      visualizar(item) {
        this.$router.push({ path: "/cadastros/emitente/" + item.ID_EMITENTE });
      }
    }
  }
  </script>
  
  <style lang="scss">
    .b-table tbody tr {
      cursor: pointer;
    }
  </style>